import { HTML5_NAMED_ENTITIES } from './html5-named-entities';

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function escapeAttr(value) {
  return escapeHtml(value);
}

function isPhpHtml5NumericCodePoint(codePoint) {
  if (!Number.isInteger(codePoint) || codePoint < 1 || codePoint > 0x10ffff) {
    return false;
  }
  if (codePoint < 32 && codePoint !== 9 && codePoint !== 10 && codePoint !== 12) {
    return false;
  }
  if (codePoint === 0x7f || (codePoint >= 0x80 && codePoint <= 0x9f)) {
    return false;
  }
  if (codePoint >= 0xd800 && codePoint <= 0xdfff) {
    return false;
  }
  if (codePoint >= 0xfdd0 && codePoint <= 0xfdef) {
    return false;
  }
  if ((codePoint & 0xfffe) === 0xfffe) {
    return false;
  }
  return true;
}

// PHP html_entity_decode($value, ENT_QUOTES | ENT_HTML5, 'UTF-8') in one pass:
// `&amp;` / `&#38;` / `&copy;` → raw characters; `&amp;amp;` → `&amp;` (do not loop-decode).
export function decodeCatalogText(value) {
  return String(value == null ? '' : value).replace(
    /&(#x[0-9a-fA-F]+|#\d+|[a-zA-Z][a-zA-Z0-9]*);/g,
    function replaceEntity(match, body) {
      if (body.charAt(0) === '#') {
        const hex = body.charAt(1) === 'x' || body.charAt(1) === 'X';
        const codePoint = hex ? parseInt(body.slice(2), 16) : parseInt(body.slice(1), 10);
        if (!isPhpHtml5NumericCodePoint(codePoint)) {
          return match;
        }
        return String.fromCodePoint(codePoint);
      }

      return Object.prototype.hasOwnProperty.call(HTML5_NAMED_ENTITIES, body)
        ? HTML5_NAMED_ENTITIES[body]
        : match;
    }
  );
}

export function decodeCatalogProduct(product) {
  const groups = (Array.isArray(product.biomarker_groups) ? product.biomarker_groups : []).map(
    function mapGroup(group) {
      const tests = (Array.isArray(group.tests) ? group.tests : []).map(function mapTest(test) {
        return Object.assign({}, test, {
          name: decodeCatalogText(test.name),
          href: decodeCatalogText(test.href),
        });
      });

      return Object.assign({}, group, {
        name: decodeCatalogText(group.name),
        icon_url: decodeCatalogText(group.icon_url),
        tests: tests,
      });
    }
  );

  return Object.assign({}, product, {
    name: decodeCatalogText(product.name),
    href: decodeCatalogText(product.href),
    search_text: decodeCatalogText(product.search_text),
    biomarker_groups: groups,
  });
}

function escapeCatalogText(value) {
  return escapeHtml(value);
}

function escapeCatalogAttr(value) {
  return escapeAttr(value);
}

function hrefAttr(href) {
  return escapeAttr(href);
}

function cartButtonHtml(product, labels) {
  const productId = String(product.id || '');
  const name = product.name || '';
  const price = product.tracking_unit_price || 0;

  return (
    '<button type="button"' +
    ' class="button-cart btn btn-primary icon small"' +
    ' data-product-id="' + escapeAttr(productId) + '"' +
    ' data-hs-in-cart="false"' +
    ' data-in-cart-label="' + escapeAttr(labels.inCartLabel) + '"' +
    ' data-add-label="' + escapeAttr(labels.cartLabel) + '"' +
    ' data-loading-text="' + escapeAttr(labels.loadingLabel) + '"' +
    ' data-tracking-price="' + escapeAttr(price) + '"' +
    ' data-product-name="' + escapeCatalogAttr(name) + '">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
    '<path d="M7 22C6.45 22 5.97917 21.8042 5.5875 21.4125C5.19583 21.0208 5 20.55 5 20C5 19.45 5.19583 18.9792 5.5875 18.5875C5.97917 18.1958 6.45 18 7 18C7.55 18 8.02083 18.1958 8.4125 18.5875C8.80417 18.9792 9 19.45 9 20C9 20.55 8.80417 21.0208 8.4125 21.4125C8.02083 21.8042 7.55 22 7 22ZM17 22C16.45 22 15.9792 21.8042 15.5875 21.4125C15.1958 21.0208 15 20.55 15 20C15 19.45 15.1958 18.9792 15.5875 18.5875C15.9792 18.1958 16.45 18 17 18C17.55 18 18.0208 18.1958 18.4125 18.5875C18.8042 18.9792 19 20 19 20C19 20.55 18.8042 21.0208 18.4125 21.4125C18.0208 21.8042 17.55 22 17 22ZM5.2 4H19.95C20.3333 4 20.625 4.17083 20.825 4.5125C21.025 4.85417 21.0333 5.2 20.85 5.55L17.3 11.95C17.1167 12.2833 16.8708 12.5417 16.5625 12.725C16.2542 12.9083 15.9167 13 15.55 13H8.1L7 15H18C18.2833 15 18.5208 15.0958 18.7125 15.2875C18.9042 15.4792 19 15.7167 19 16C19 16.2833 18.9042 16.5208 18.7125 16.7125C18.5208 16.9042 18.2833 17 18 17H7C6.25 17 5.68333 16.6708 5.3 16.0125C4.91667 15.3542 4.9 14.7 5.25 14.05L6.6 11.6L3 4H2C1.71667 4 1.47917 3.90417 1.2875 3.7125C1.09583 3.52083 1 3.28333 1 3C1 2.71667 1.09583 2.47917 1.2875 2.2875C1.47917 2.09583 1.71667 2 2 2H3.625C3.80833 2 3.98333 2.05 4.15 2.15C4.31667 2.25 4.44167 2.39167 4.525 2.575L5.2 4Z" fill="#7CFC00"/>' +
    '</svg>' +
    '<span>' + escapeHtml(labels.cartLabel) + '</span>' +
    '</button>'
  );
}

function groupPanelHtml(product, group, groupCount, labels) {
  const productId = String(product.id || '');
  const panelId = 'hs-card-group-' + productId + '-' + group.group_id;
  const tests = Array.isArray(group.tests) ? group.tests : [];
  const hidden = groupCount > 1 ? ' hidden' : '';
  let body;

  if (groupCount === 1 && tests.length === 1) {
    const test = tests[0];
    body =
      '<div class="hs-card-groups__solo" data-testid="hs-card-group-solo">' +
      '<img src="' + hrefAttr(group.icon_url) + '" alt="" aria-hidden="true" width="28" height="36" data-testid="hs-card-group-solo-icon">' +
      '<div class="hs-card-groups__solo-copy">' +
      '<p class="hs-card-groups__name">' + escapeCatalogText(group.name) + '</p>' +
      '<a href="' + hrefAttr(test.href) + '" data-testid="hs-card-group-test-link">' + escapeCatalogText(test.name) + '</a>' +
      '</div></div>';
  } else {
    const items = tests.map(function mapTest(test) {
      return (
        '<li><a href="' + hrefAttr(test.href) + '" data-testid="hs-card-group-test-link">' +
        escapeCatalogText(test.name) +
        '</a></li>'
      );
    }).join('');

    body =
      '<p class="hs-card-groups__name">' + escapeCatalogText(group.name) + '</p>' +
      '<ul class="hs-card-groups__tests">' + items + '</ul>';
  }

  return (
    '<div id="' + escapeAttr(panelId) + '"' +
    ' class="hs-card-groups__panel"' +
    ' data-testid="hs-card-group-panel"' +
    ' data-hs-card-group-id="' + escapeAttr(group.group_id) + '"' +
    hidden + '>' +
    body +
    '</div>'
  );
}

function groupsHtml(product, labels) {
  const groups = Array.isArray(product.biomarker_groups) ? product.biomarker_groups : [];
  if (!groups.length) {
    return '';
  }

  const groupCount = groups.length;
  const productId = String(product.id || '');
  const singleClass = groupCount === 1 ? ' hs-card-groups--single' : '';
  let icons = '';
  let showAll = '';

  if (groupCount > 1) {
    icons = '<div class="hs-card-groups__icons" role="group">' + groups.map(function mapIcon(group) {
      const panelId = 'hs-card-group-' + productId + '-' + group.group_id;
      return (
        '<button type="button"' +
        ' class="hs-card-groups__icon"' +
        ' data-testid="hs-card-group-icon"' +
        ' data-hs-card-group-id="' + escapeAttr(group.group_id) + '"' +
        ' aria-label="' + escapeCatalogAttr(group.name) + '"' +
        ' aria-expanded="false"' +
        ' aria-controls="' + escapeAttr(panelId) + '">' +
        '<img src="' + hrefAttr(group.icon_url) + '" alt="" aria-hidden="true" width="28" height="36">' +
        '</button>'
      );
    }).join('') + '</div>';
  }

  if (groupCount >= 3) {
    showAll =
      '<button type="button"' +
      ' class="hs-card-groups__show-all"' +
      ' data-testid="hs-card-group-show-all"' +
      ' aria-expanded="false"' +
      ' aria-controls="hs-card-groups-panels-' + escapeAttr(productId) + '">' +
      escapeHtml(labels.showAllLabel) +
      '</button>';
  }

  const panels = groups.map(function mapPanel(group) {
    return groupPanelHtml(product, group, groupCount, labels);
  }).join('');

  return (
    '<div class="hs-card-groups' + singleClass + '"' +
    ' data-hs-card-groups' +
    ' data-testid="hs-card-groups"' +
    ' data-show-all-label="' + escapeAttr(labels.showAllLabel) + '"' +
    ' data-hide-label="' + escapeAttr(labels.hideLabel) + '">' +
    icons +
    showAll +
    '<div id="hs-card-groups-panels-' + escapeAttr(productId) + '" class="hs-card-groups__panels">' +
    panels +
    '</div></div>'
  );
}

function tagsHtml(product, labels) {
  const showSale = Boolean(product.special && product.price);
  const showNew = Boolean(product.is_new);
  if (!showSale && !showNew) {
    return '';
  }

  let chips = '';
  if (showSale) {
    chips +=
      '<p class="hs-commerce-sale" data-testid="hs-commerce-sale">' +
      escapeHtml(labels.saleLabel || 'SALE') +
      '</p>';
  }
  if (showNew) {
    chips +=
      '<p class="hs-commerce-new" data-testid="hs-commerce-new">' +
      escapeHtml(labels.newLabel || 'NEW') +
      '</p>';
  }

  return '<div class="tags">' + chips + '</div>';
}

export function renderProductCard(product, labels) {
  const tracking = labels.trackingEntrypoint
    ? ' data-tracking-entrypoint="' + escapeAttr(labels.trackingEntrypoint) + '"'
    : '';
  const special = product.special;
  let priceHtml = '';

  if (product.price) {
    const priceInner = special
      ? '<p>' + escapeHtml(special) + '</p><span class="discount">' + escapeHtml(product.price) + '</span>'
      : '<p>' + escapeHtml(product.price) + '</p>';

    priceHtml =
      '<div class="price"><div class="price-row">' + priceInner + '</div></div>' +
      '<div class="form-group">' +
      '<input type="hidden" name="product_id" value="' + escapeAttr(product.id) + '"/>' +
      cartButtonHtml(product, labels) +
      '</div>';
  }

  return (
    '<div class="item card hs-commerce-card"' + tracking + '>' +
    '<div class="card-content">' +
    tagsHtml(product, labels) +
    '<a class="title" href="' + hrefAttr(product.href) + '">' + escapeCatalogText(product.name) + '</a>' +
    groupsHtml(product, labels) +
    priceHtml +
    '</div></div>'
  );
}

export function renderProductCards(products, labels) {
  if (!products || !products.length) {
    return '';
  }

  return (
    '<div class="list-group cards">' +
    products.map(function mapCard(product) {
      return renderProductCard(product, labels);
    }).join('') +
    '</div>'
  );
}
